<template>
  <div v-if="isVisible" class="error-toast-overlay">
    <div class="error-toast">
      <p>{{ errorMessage }}</p>
      <button @click="close">Close</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    errorMessage: String,
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    show() {
      this.isVisible = true;
      document.body.style.overflow = 'hidden';
    },
    close() {
      this.isVisible = false;
      document.body.style.overflow = '';
    },
  },
};
</script>

<style scoped>
.error-toast-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.error-toast {
  background-color: white;
  color: #721c24;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 80%;
  width: 300px;
  text-align: center;
  margin-bottom: 4em;
}

.error-toast button {
  margin-top: 10px;
  padding: 5px 10px;
  background-color: #721c24;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}
</style>
